import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Related Components
import Tooltip from './tooltip';

export default class Badge extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    stacked: PropTypes.bool,
    color: PropTypes.oneOf(['dark', 'light']),
    size: PropTypes.oneOf(['sm', 'md', 'lg', 'xlg']),
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    onClick: PropTypes.func,
    clearable: PropTypes.bool,
    hoverable: PropTypes.bool,
    selected: PropTypes.bool,
    selectable: PropTypes.bool,
    isAI: PropTypes.bool,
  }

  static defaultProps = {
    size: 'md',
    color: 'dark',
    onClick: () => { },
    clearable: false,
    text: ' ',
    hoverable: true,
    selected: false,
    selectable: false,
    isAI: false,
  }

  get classNames() {
    const {
      size,
      className,
      color,
      stacked,
      clearable,
      selected,
      selectable,
      isAI,
    } = this.props;

    return classNames('badge', {
      'is-stacked': stacked,
      'badge-xlg': size === 'xlg',
      'badge-lg': size === 'lg',
      'badge-sm': size === 'sm',
      'is-light': color === 'light',
      'is-clearable': clearable,
      'is-selected': selected,
      'is-selectable': selectable,
      'is-ai': isAI,
      [className]: className,
    });
  }

  render() {
    const { text, children, onClick, clearable, hoverable } = this.props;

    return (
      <div
        onClick={onClick}
        className={this.classNames}
      >
        {hoverable ? (
          <Tooltip content={text || children}>
            {children || text}
            {clearable && <div className='clear-icon margin-left-5'>x</div>}
          </Tooltip>
        ) : (
          <div>
            {children || text}
            {clearable && <div className='clear-icon margin-left-5'>x</div>}
          </div>
        )}
      </div>
    );
  }
}
